import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline',
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(0.5, 0),
    fontSize: 'inherit',
    fontWeight: 'bold',
  },
}));

const HighlightedTypography = ({ children }) => {
  const classes = useStyles();
  return <Typography className={classes.root}>{children}</Typography>;
};

export default HighlightedTypography;
